import { Component, OnInit, Input } from '@angular/core';
import { NgForm } from '@angular/forms';

import { settings } from '../../../app.settings';

@Component({
  selector: 'app-auth-sso-form',
  templateUrl: './auth-sso-form.component.html',
  styleUrls: ['./auth-sso-form.component.sass']
})
export class AuthSsoFormComponent implements OnInit {
  @Input() model: any = {};
  @Input() captcha = false;

  public form: NgForm;
  public captachKey = settings.keys.captcha;

  ngOnInit() {
  }

  onSubmit(form: NgForm) {
    this.form = form;
  }
}
